/** /{ws}/scheduled — my scheduled messages (core ScheduledViewModel): edit, reschedule, send now, cancel. */
import { Shell } from "@bundle/core";
import { ComingSoon, ScheduledList, Stack, Text, useNavigation, useScheduled, useT, useWorkspace } from "@bundle/ui";
import { useEffect } from "react";

export function ScheduledScreen() {
  const t = useT();
  const nav = useNavigation();
  const ws = useWorkspace();
  const vm = useScheduled();
  // Opening the list takes the server's latest (messages that went out meanwhile).
  useEffect(() => void vm?.refresh(), [vm]);
  if (vm === undefined) return <ComingSoon icon="send" title={t("scheduled.title")} body={t("scheduled.empty")} />;
  return (
    <Stack grow testID="scheduled-screen">
      <Stack paddingX="8" paddingY="4">
        <Text variant="title2" weight="bold">
          {t("scheduled.title")}
        </Text>
      </Stack>
      <ScheduledList
        vm={vm}
        onOpen={(row) =>
          nav.open(
            row.scheduled.threadRootId === undefined
              ? Shell.formatUrl({ type: "channel", ws: ws.slug, channelId: row.scheduled.channelId })
              : Shell.formatUrl({ type: "thread", ws: ws.slug, channelId: row.scheduled.channelId, rootId: row.scheduled.threadRootId }),
          )
        }
        testID="scheduled"
      />
    </Stack>
  );
}
